import {CommonModule} from '@angular/common';
import {ErrorHandler, NgModule, Optional, SkipSelf} from '@angular/core';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {RouterStateSerializer, StoreRouterConnectingModule} from '@ngrx/router-store';
import {StoreModule} from '@ngrx/store';
import {EffectsModule} from '@ngrx/effects';
import {StoreDevtoolsModule} from '@ngrx/store-devtools';
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {FormsModule} from '@angular/forms';

import {environment} from '../../environments/environment';

import {AppState, metaReducers, reducers, selectRouterState} from './core.state';
import {AuthEffects} from './auth/auth.effects';
import {selectAuth, selectIsAuthenticated} from './auth/auth.selectors';
import {authLogin, authLogout} from './auth/auth.actions';
import {AuthGuardService} from './auth/auth-guard.service';
import {ROUTE_ANIMATIONS_ELEMENTS, routeAnimations} from './animations/route.animations';
import {AnimationsService} from './animations/animations.service';
import {AppErrorHandler} from './error-handler/app-error-handler.service';
import {CustomSerializer} from './router/custom-serializer';
import {LocalStorageService} from './local-storage/local-storage.service';
import {NotificationService} from './notifications/notification.service';
import {MatSnackBarModule} from '@angular/material/snack-bar';

import {NgxMaskConfig, provideEnvironmentNgxMask} from 'ngx-mask'

const maskConfig: Partial<NgxMaskConfig > = {};

export {
  selectAuth,
  authLogin,
  authLogout,
  routeAnimations,
  AppState,
  LocalStorageService,
  selectIsAuthenticated,
  ROUTE_ANIMATIONS_ELEMENTS,
  AnimationsService,
  AuthGuardService,
  selectRouterState,
  NotificationService,
};

@NgModule({ declarations: [],
    exports: [TranslateModule], imports: [
        // angular
        CommonModule,
        FormsModule,
        // ngrx
        StoreModule.forRoot(reducers, { metaReducers }),
        StoreRouterConnectingModule.forRoot(),
        EffectsModule.forRoot([
            AuthEffects,
        ]),
        environment.production
            ? []
            : StoreDevtoolsModule.instrument({
                name: 'Alpes Controles POC Web',
                connectInZone: true
            }),
        // i18n
        TranslateModule.forRoot({
            loader: provideTranslateHttpLoader({prefix: `${environment.i18nPrefix}/assets/i18n/`, suffix: '.json'})
        }),
        //Custom UI // TODO : REMOVE THIS
        MatSnackBarModule], providers: [
        { provide: ErrorHandler, useClass: AppErrorHandler },
        { provide: RouterStateSerializer, useClass: CustomSerializer },
        provideEnvironmentNgxMask(maskConfig),
        provideHttpClient(withInterceptorsFromDi()),
    ] })
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule,
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
